/** Fixed top AppBar height — baseline clearance (matches HorizontalBar `top`). */
export const APP_HEADER_OFFSET_PX = 62;

/** Extra space below the header before `<main>` starts (0 avoids double gap with inner page padding). */
export const MAIN_SECTION_TOP_EXTRA_PX = 0;

/** Total `<main>` margin-top and related layout (sidebar height, sticky panels). */
export const MAIN_MARGIN_TOP_PX = APP_HEADER_OFFSET_PX + MAIN_SECTION_TOP_EXTRA_PX;

/** Second row when using horizontal menu layout (matches HorizontalBar `height`). */
export const HORIZONTAL_MENU_BAR_HEIGHT_PX = 62;

/** AppBar + extra + horizontal strip + borders — offset for main in horizontal layout. */
export const MAIN_OFFSET_HORIZONTAL_LAYOUT_PX = MAIN_MARGIN_TOP_PX + HORIZONTAL_MENU_BAR_HEIGHT_PX + 2;

const LAYOUT_CONST = {
    VERTICAL_LAYOUT: 'vertical',
    HORIZONTAL_LAYOUT: 'horizontal',
    DEFAULT_DRAWER: 'default',
    MINI_DRAWER: 'mini-drawer'
};

export default LAYOUT_CONST;
